<template>
  <div>
    <div class="col-sm">
      <div class="card">
        <div class="card-body text-center">

          <a href="#/integrations" @click.prevent="startIntegration">
            <img v-bind:src="logo" width="80" class="img-responsive">
          </a>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="step1Modal"
      aria-hidden="true"
      id="ebay-modal"
    >
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">Connect your eBay Store</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <!-- <label for="ebay_username">Ebay Username</label> -->
              <input
                type="text"
                class="form-control"
                id="ebay_username"
                aria-describedby="emailHelp"
                placeholder="eBay Username"
                v-model="ebay_user"
              >
              <small
                id="ebay_username_help"
                class="form-text text-muted"
              >Please enter the username for your eBay account.</small>
            </div>
            <div class="form-group">
              <div class="input-group default">
                <input
                  type="text"
                  class="form-control form-control-sm"
                  placeholder="Nickname (optional)"
                  aria-describedby="basic-addon1"
                  v-model="nickname"
                >
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <b-btn class="btn-blue" @click="submitStep1">Continue</b-btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    logo: null,
    code: null,
    marketplace: null,
    prompt,
  },

  data() {
    return {
      ebay_user: null,
      nickname: ''
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser"
    })
  },

  methods: {
    startIntegration(event) {
      $("#ebay-modal").modal();
   },
    submitStep1() {
      console.log(this.code);

      axios
        .post("/integrate/ebay", {
          ebay_user: this.ebay_user,
          nickname: this.nickname
        })
        .then(function(response) {
          //console.log(response.data);
          const {data: {url}} = response;
          console.log(url);
          window.location = url;
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/NewIntegrationEbay.vue